<template>
	<div class="form-group clearfix">
		<div
			:class="{'float-left': (field.labelStyle=='justify'||field.labelStyle=='inline')}"
		>
			<label v-if="field.question" class="mr-2 align-top" :for="field.id">{{ field.question }}</label>
			<div v-if="field.description" v-html="field.description" class="mr-2"></div>
		</div>
		<textarea-autosize
			class="form-control align-top"
			:class="{'float-right': (field.labelStyle=='justify')}"
			v-bind:style="{ 'display': (field.labelStyle=='justify'||field.labelStyle=='inline'?'inline':''), 'width': (field.labelStyle=='justify'||field.labelStyle=='inline'?'auto':'') }"
			v-model="field.value"
			:readonly="readonly"
			@keydown.native="checkWords"
			:id="field.id"
			:aria-label="field.question"
		></textarea-autosize>
	</div>
</template>

<script>
export default {
	props: ['field', 'readonly'],
	methods: {
		checkWords(e) {
			if(this.field.maxWords) {
				var BACKSPACE  = 8;
				var DELETE     = 46;
				var valid_keys = [BACKSPACE, DELETE];
				var words      = this.field.value.split(/\s+/);

				if (words.length > this.field.maxWords && valid_keys.indexOf(e.keyCode) == -1) {
					e.preventDefault();
			    }
			}
		}
	},
	computed: {
	}
};
</script>
